import Dict from '@baifendian/adherev-util-dict';
import Intl from '@baifendian/adherev-util-intl';
export default {
    initStatic: function () {
        Dict.handlers.ResourceGisEpsg4326 = function () { return 'EPSG:4326'; };
        Dict.handlers.ResourceGisEpsg3857 = function () { return 'EPSG:3857'; };
        Dict.handlers.ResourceGisEarthRadius = function () { return 6378137.0; }; // 单位M
        Dict.handlers.ResourceGisMapMaxZoom = function () { return 17; };
        Dict.handlers.ResourceGisMapMinZoom = function () { return 11; };
        // 常州市新北区的geoJSON数据
        Dict.handlers.ResourceGisXinbeiquGeoJSON = function () { return ({
            type: 'FeatureCollection',
            features: [
                {
                    type: 'Feature',
                    properties: {
                        adcode: 320411,
                        name: Intl.tv('新北区'),
                        center: [119.974654, 31.824664],
                        centroid: [119.887323, 31.925024],
                        childrenNum: 0,
                        level: 'district',
                        subFeatureIndex: 2,
                        acroutes: [100000, 320000, 320400],
                        parent: { adcode: 320400 },
                    },
                    geometry: {
                        type: 'MultiPolygon',
                        coordinates: [
                            [
                                [
                                    [119.7493459, 31.8885404],
                                    [119.7497556, 31.8847773],
                                    [119.7550551, 31.8790072],
                                    [119.7612496, 31.8736603],
                                    [119.761142, 31.8647861],
                                    [119.7586592, 31.861709],
                                    [119.762329, 31.8558587],
                                    [119.7641014, 31.8555412],
                                    [119.7636422, 31.8544483],
                                    [119.7660109, 31.8504396],
                                    [119.7701492, 31.8512531],
                                    [119.7730089, 31.8507856],
                                    [119.7768279, 31.8550737],
                                    [119.7844788, 31.8557137],
                                    [119.7836429, 31.8523682],
                                    [119.7894948, 31.8553254],
                                    [119.7937172, 31.8560175],
                                    [119.7947542, 31.8543187],
                                    [119.8034432, 31.8545966],
                                    [119.8066016, 31.8541387],
                                    [119.7996172, 31.8406124],
                                    [119.7951246, 31.8338677],
                                    [119.789886, 31.8310034],
                                    [119.7861563, 31.8304572],
                                    [119.7891152, 31.8238911],
                                    [119.7863096, 31.8209025],
                                    [119.7839392, 31.8231054],
                                    [119.7816476, 31.8199605],
                                    [119.7834554, 31.8140653],
                                    [119.7856429, 31.8137898],
                                    [119.7843156, 31.812184],
                                    [119.7831177, 31.8107599],
                                    [119.7836658, 31.8101545],
                                    [119.7846634, 31.8098657],
                                    [119.7857849, 31.809761],
                                    [119.7874857, 31.8100542],
                                    [119.7883484, 31.8108188],
                                    [119.7892111, 31.8112168],
                                    [119.7917375, 31.8118242],
                                    [119.7925756, 31.8122012],
                                    [119.7929576, 31.8125992],
                                    [119.7936971, 31.8120651],
                                    [119.7936478, 31.811688],
                                    [119.7944612, 31.8113529],
                                    [119.7943133, 31.8110178],
                                    [119.7947323, 31.8105674],
                                    [119.7953276, 31.8105798],
                                    [119.7957016, 31.81087],
                                    [119.795978, 31.8106973],
                                    [119.7963764, 31.8112155],
                                    [119.7966692, 31.8110358],
                                    [119.797035, 31.8114021],
                                    [119.7977099, 31.8123003],
                                    [119.7978481, 31.812093],
                                    [119.7981002, 31.8117475],
                                    [119.7981246, 31.8111948],
                                    [119.7976042, 31.8100339],
                                    [119.7977831, 31.8089699],
                                    [119.7984661, 31.8074221],
                                    [119.7993849, 31.8064685],
                                    [119.8004663, 31.8058397],
                                    [119.8021134, 31.8058196],
                                    [119.8034814, 31.8056939],
                                    [119.8035553, 31.8062909],
                                    [119.8040976, 31.807422],
                                    [119.8043318, 31.8073383],
                                    [119.8051082, 31.8069298],
                                    [119.8056504, 31.806867],
                                    [119.8060941, 31.8065946],
                                    [119.8056381, 31.8059977],
                                    [119.8065008, 31.805474],
                                    [119.8071293, 31.8063223],
                                    [119.8065008, 31.806647],
                                    [119.8069322, 31.8077362],
                                    [119.8074744, 31.8075582],
                                    [119.8071663, 31.8068355],
                                    [119.8079182, 31.8065898],
                                    [119.8084002, 31.8085596],
                                    [119.811073, 31.8132369],
                                    [119.8149921, 31.8105007],
                                    [119.8160166, 31.8114957],
                                    [119.816537, 31.8131125],
                                    [119.8156426, 31.8135409],
                                    [119.8164557, 31.8150195],
                                    [119.8166833, 31.8160697],
                                    [119.8175127, 31.8155999],
                                    [119.8173501, 31.8161112],
                                    [119.8178379, 31.8164843],
                                    [119.8174964, 31.8169541],
                                    [119.8178217, 31.8171199],
                                    [119.819269, 31.8167468],
                                    [119.8191389, 31.8179352],
                                    [119.8211554, 31.8177279],
                                    [119.8214481, 31.8165948],
                                    [119.8213342, 31.8159454],
                                    [119.8216432, 31.8155584],
                                    [119.822066, 31.8154341],
                                    [119.8234645, 31.8167054],
                                    [119.8237573, 31.8164981],
                                    [119.8247818, 31.8173825],
                                    [119.8262453, 31.817797],
                                    [119.8273511, 31.8177003],
                                    [119.831628, 31.8174101],
                                    [119.8319045, 31.8172166],
                                    [119.8330265, 31.8158763],
                                    [119.8344413, 31.8151024],
                                    [119.8361325, 31.8138864],
                                    [119.8370595, 31.8151024],
                                    [119.8381165, 31.8138311],
                                    [119.8385068, 31.8141351],
                                    [119.8395638, 31.8142595],
                                    [119.8400354, 31.8130987],
                                    [119.8406859, 31.8126289],
                                    [119.8422633, 31.815517],
                                    [119.8427186, 31.815365],
                                    [119.8442472, 31.8179905],
                                    [119.8456783, 31.8202704],
                                    [119.8436455, 31.8207679],
                                    [119.8450928, 31.8236281],
                                    [119.846654, 31.8253553],
                                    [119.8478736, 31.8280081],
                                    [119.8498413, 31.825452],
                                    [119.8516952, 31.8266264],
                                    [119.8521668, 31.8262257],
                                    [119.8531099, 31.8264744],
                                    [119.8524595, 31.8282982],
                                    [119.8530286, 31.8298457],
                                    [119.8504105, 31.832305],
                                    [119.8527847, 31.8348195],
                                    [119.8549963, 31.8334931],
                                    [119.8602326, 31.8310615],
                                    [119.8663407, 31.8276127],
                                    [119.8685429, 31.8264049],
                                    [119.8721195, 31.8323269],
                                    [119.8779453, 31.8418913],
                                    [119.8836596, 31.8513038],
                                    [119.8854608, 31.850797],
                                    [119.8855107, 31.8503872],
                                    [119.8875568, 31.8509665],
                                    [119.886958, 31.8490872],
                                    [119.8872407, 31.8477589],
                                    [119.887091, 31.847547],
                                    [119.887274, 31.8470383],
                                    [119.8870744, 31.8464024],
                                    [119.8883886, 31.8466709],
                                    [119.888871, 31.8463882],
                                    [119.8889209, 31.8460491],
                                    [119.890601, 31.8459502],
                                    [119.8905678, 31.8455545],
                                    [119.8914328, 31.8454273],
                                    [119.8917988, 31.8458654],
                                    [119.8895198, 31.8468546],
                                    [119.8891205, 31.8466002],
                                    [119.8883387, 31.8469393],
                                    [119.8894698, 31.8488894],
                                    [119.889237, 31.8492144],
                                    [119.8894366, 31.84961],
                                    [119.8897526, 31.8494122],
                                    [119.8901852, 31.8500905],
                                    [119.8912165, 31.8497796],
                                    [119.8914206, 31.8501867],
                                    [119.8960204, 31.848457],
                                    [119.8957246, 31.8478578],
                                    [119.897919, 31.8468855],
                                    [119.8974381, 31.8458937],
                                    [119.8988021, 31.8456393],
                                    [119.8994009, 31.8471146],
                                    [119.9051894, 31.8445376],
                                    [119.9038501, 31.8423631],
                                    [119.9041087, 31.8422478],
                                    [119.9037235, 31.8415584],
                                    [119.9061378, 31.8393612],
                                    [119.9060267, 31.8385802],
                                    [119.9070199, 31.8378528],
                                    [119.905338, 31.8348139],
                                    [119.9083008, 31.8333162],
                                    [119.9107628, 31.8332597],
                                    [119.9112784, 31.8338674],
                                    [119.9121601, 31.8337261],
                                    [119.9124096, 31.8330901],
                                    [119.9130418, 31.8329205],
                                    [119.9143892, 31.8325389],
                                    [119.9150546, 31.8316344],
                                    [119.9161026, 31.8312952],
                                    [119.9158697, 31.8303058],
                                    [119.9164852, 31.8301362],
                                    [119.9164519, 31.8294578],
                                    [119.9185521, 31.828314],
                                    [119.919912, 31.8283554],
                                    [119.9208602, 31.8280445],
                                    [119.9216678, 31.8263319],
                                    [119.9224572, 31.825359],
                                    [119.9226568, 31.8246664],
                                    [119.9220746, 31.823677],
                                    [119.9214924, 31.8218113],
                                    [119.9215589, 31.8207653],
                                    [119.9208935, 31.8186168],
                                    [119.9208935, 31.8169629],
                                    [119.919925, 31.8143061],
                                    [119.919861, 31.8128919],
                                    [119.9291611, 31.809697],
                                    [119.9426256, 31.8049823],
                                    [119.9447659, 31.8106583],
                                    [119.9449666, 31.8111905],
                                    [119.9458403, 31.8110436],
                                    [119.9474157, 31.8114707],
                                    [119.9524129, 31.8122629],
                                    [119.9578822, 31.8123805],
                                    [119.9586462, 31.8121775],
                                    [119.9665248, 31.8092103],
                                    [119.9667732, 31.8089705],
                                    [119.9671079, 31.8087252],
                                    [119.9673795, 31.8085803],
                                    [119.9676577, 31.8083578],
                                    [119.9680023, 31.8082069],
                                    [119.9685322, 31.8080251],
                                    [119.9686941, 31.8079382],
                                    [119.968828, 31.8077948],
                                    [119.9688887, 31.807706],
                                    [119.9688941, 31.8075941],
                                    [119.9688164, 31.8074926],
                                    [119.968762, 31.8073673],
                                    [119.9687207, 31.8072084],
                                    [119.9687148, 31.8071168],
                                    [119.9687613, 31.806954],
                                    [119.968913, 31.8068508],
                                    [119.9691207, 31.8068031],
                                    [119.9694519, 31.8065989],
                                    [119.969601, 31.8064343],
                                    [119.9697036, 31.8062825],
                                    [119.9697783, 31.8061147],
                                    [119.9698508, 31.8058623],
                                    [119.9753121, 31.8002159],
                                    [119.9879923, 31.8085676],
                                    [119.9907993, 31.809399],
                                    [119.9955896, 31.8099313],
                                    [119.9995419, 31.8107359],
                                    [120.0020606, 31.8111642],
                                    [120.0034932, 31.8122428],
                                    [120.00438, 31.8123657],
                                    [120.0048276, 31.8126916],
                                    [120.0048829, 31.8131127],
                                    [120.0052416, 31.8132081],
                                    [120.0051786, 31.8135702],
                                    [120.0056431, 31.8138038],
                                    [120.0060531, 31.8137191],
                                    [120.0060655, 31.8142451],
                                    [120.0057416, 31.8143284],
                                    [120.0058754, 31.8152754],
                                    [120.0058399, 31.8160551],
                                    [120.0067404, 31.8162757],
                                    [120.0067706, 31.8171645],
                                    [120.006236, 31.8171887],
                                    [120.0059686, 31.8176624],
                                    [120.0067605, 31.8184065],
                                    [120.0071585, 31.8190467],
                                    [120.0074756, 31.8194771],
                                    [120.0071633, 31.8205839],
                                    [120.0067214, 31.8217812],
                                    [120.0058937, 31.8233843],
                                    [120.0044075, 31.825009],
                                    [120.0028788, 31.8261421],
                                    [120.0012369, 31.8270106],
                                    [120.0013135, 31.8270569],
                                    [120.0013185, 31.8273729],
                                    [120.0006441, 31.8278933],
                                    [120.0000408, 31.8281436],
                                    [119.9997643, 31.828432],
                                    [119.9988212, 31.8290551],
                                    [119.9976005, 31.8299511],
                                    [119.9979868, 31.830931],
                                    [119.9981496, 31.8313991],
                                    [119.9981745, 31.8314187],
                                    [119.9983934, 31.8314385],
                                    [119.9984685, 31.8317849],
                                    [119.9985715, 31.8317742],
                                    [119.9985221, 31.8314294],
                                    [119.9987163, 31.8314232],
                                    [119.9987651, 31.8319879],
                                    [119.9983499, 31.831982],
                                    [119.9985393, 31.8327039],
                                    [119.9987056, 31.8335562],
                                    [119.9987617, 31.8346336],
                                    [119.9987968, 31.8349963],
                                    [119.9988665, 31.83537],
                                    [119.9994126, 31.8361464],
                                    [120.0000521, 31.8357802],
                                    [120.0002709, 31.8360598],
                                    [120.000567, 31.8364821],
                                    [120.0006647, 31.8367496],
                                    [120.0001524, 31.8368845],
                                    [120.0002991, 31.8374008],
                                    [120.0004096, 31.8374963],
                                    [120.0005904, 31.8375223],
                                    [120.0008143, 31.8375626],
                                    [120.001015, 31.837692],
                                    [120.0008514, 31.8378812],
                                    [120.0009305, 31.838266],
                                    [120.0008996, 31.8384827],
                                    [120.0004168, 31.8391845],
                                    [119.999918, 31.8389931],
                                    [119.9997409, 31.8395537],
                                    [119.999698, 31.8396767],
                                    [119.9989577, 31.8395081],
                                    [119.99877, 31.8403102],
                                    [119.9986777, 31.840289],
                                    [119.9985715, 31.8406611],
                                    [119.9958356, 31.8397633],
                                    [119.996062, 31.8407231],
                                    [119.9961916, 31.8415408],
                                    [119.9962929, 31.842403],
                                    [119.9962929, 31.843198],
                                    [119.9962391, 31.8435805],
                                    [119.9956747, 31.8475968],
                                    [119.9942864, 31.8478181],
                                    [119.993296, 31.8478798],
                                    [119.9926771, 31.8479183],
                                    [119.9926659, 31.8480134],
                                    [119.9926282, 31.8483325],
                                    [119.9922592, 31.849525],
                                    [119.992595, 31.8498103],
                                    [119.9924764, 31.8499771],
                                    [119.9920537, 31.850158],
                                    [119.9920752, 31.851042],
                                    [119.9902727, 31.8511349],
                                    [119.9889896, 31.8512803],
                                    [119.9888887, 31.8515159],
                                    [119.9872515, 31.8511436],
                                    [119.9870826, 31.8511891],
                                    [119.9875233, 31.851789],
                                    [119.987899, 31.8521386],
                                    [119.9874138, 31.8525959],
                                    [119.9869725, 31.8532761],
                                    [119.9859533, 31.8529936],
                                    [119.985, 31.8531293],
                                    [119.9849566, 31.8534248],
                                    [119.9850692, 31.8540536],
                                    [119.9845639, 31.8541272],
                                    [119.9845921, 31.8551611],
                                    [119.984701, 31.8561626],
                                    [119.9861961, 31.8562567],
                                    [119.9862494, 31.8560448],
                                    [119.9886551, 31.8561476],
                                    [119.9887331, 31.8569925],
                                    [119.9893973, 31.856903],
                                    [119.989821, 31.8570078],
                                    [119.9902352, 31.8572614],
                                    [119.9907223, 31.8575637],
                                    [119.9907759, 31.8577095],
                                    [119.9906708, 31.85812],
                                    [119.9914609, 31.8584216],
                                    [119.9912292, 31.8590187],
                                    [119.9918319, 31.8591345],
                                    [119.9920151, 31.8586162],
                                    [119.9923756, 31.858888],
                                    [119.9928906, 31.8592251],
                                    [119.993147, 31.8593406],
                                    [119.9937639, 31.8594591],
                                    [119.9943272, 31.859655],
                                    [119.9946544, 31.8596915],
                                    [119.9951007, 31.8597172],
                                    [119.9955835, 31.8597992],
                                    [119.9961642, 31.8599407],
                                    [119.996592, 31.8581544],
                                    [119.9968645, 31.8569303],
                                    [119.9972569, 31.8570723],
                                    [119.996669, 31.8591228],
                                    [119.9977014, 31.8595776],
                                    [120.0001433, 31.8607241],
                                    [119.9998901, 31.8609809],
                                    [119.9995693, 31.8611524],
                                    [119.9993654, 31.861198],
                                    [119.9992678, 31.8613681],
                                    [119.9992796, 31.8616627],
                                    [119.9994673, 31.8621046],
                                    [119.9994995, 31.8623233],
                                    [119.9994673, 31.8625921],
                                    [119.9989344, 31.8645107],
                                    [120.0002256, 31.8647551],
                                    [120.0003509, 31.864667],
                                    [120.0011778, 31.8650647],
                                    [120.0013897, 31.8650761],
                                    [120.0016571, 31.8653059],
                                    [120.0021305, 31.8651321],
                                    [120.0022735, 31.8649998],
                                    [120.0024127, 31.8649727],
                                    [120.002601, 31.8649734],
                                    [120.002848, 31.8650631],
                                    [120.0031522, 31.8650585],
                                    [120.0032613, 31.8654627],
                                    [120.0034021, 31.8654588],
                                    [120.0034622, 31.8655287],
                                    [120.0037001, 31.8654649],
                                    [120.0038383, 31.8659788],
                                    [120.0042857, 31.8659171],
                                    [120.0044133, 31.8659271],
                                    [120.0045571, 31.8658741],
                                    [120.0046858, 31.8658558],
                                    [120.0050356, 31.8659545],
                                    [120.0051322, 31.8664921],
                                    [120.004762, 31.8665604],
                                    [120.0048736, 31.8667215],
                                    [120.0048425, 31.8668657],
                                    [120.004625, 31.8670518],
                                    [120.004626, 31.8671654],
                                    [120.0049098, 31.8672379],
                                    [120.0051563, 31.8672743],
                                    [120.0052164, 31.8674962],
                                    [120.0046279, 31.8673941],
                                    [120.00429, 31.867303],
                                    [120.0039252, 31.8671618],
                                    [120.0036827, 31.8670313],
                                    [120.0032707, 31.8669158],
                                    [120.0032332, 31.8676584],
                                    [120.0032546, 31.8683827],
                                    [120.0032439, 31.8687427],
                                    [120.0042685, 31.8689978],
                                    [120.0044498, 31.868562],
                                    [120.0045957, 31.868237],
                                    [120.0047663, 31.8682112],
                                    [120.0047567, 31.8682643],
                                    [120.0046494, 31.868319],
                                    [120.004585, 31.8684693],
                                    [120.0045206, 31.8686515],
                                    [120.0044096, 31.8689921],
                                    [120.0041553, 31.8693939],
                                    [120.0042953, 31.8695308],
                                    [120.0044874, 31.8695916],
                                    [120.0047406, 31.8695764],
                                    [120.0049122, 31.8695855],
                                    [120.0051257, 31.8696281],
                                    [120.005395, 31.8696083],
                                    [120.0056901, 31.869631],
                                    [120.0058027, 31.869713],
                                    [120.0058027, 31.8698953],
                                    [120.005851, 31.8701732],
                                    [120.005925, 31.8703707],
                                    [120.0059779, 31.8704139],
                                    [120.0060661, 31.8704007],
                                    [120.006315, 31.8703408],
                                    [120.0064794, 31.8703877],
                                    [120.0065969, 31.8705196],
                                    [120.0072511, 31.8713121],
                                    [120.0072297, 31.8713986],
                                    [120.0070902, 31.8715353],
                                    [120.0068745, 31.8716645],
                                    [120.0068102, 31.8717282],
                                    [120.0068971, 31.8718952],
                                    [120.0074442, 31.8724555],
                                    [120.0081427, 31.8727794],
                                    [120.008383, 31.8728701],
                                    [120.0081631, 31.8730387],
                                    [120.0083111, 31.8736607],
                                    [120.0056203, 31.8757398],
                                    [120.0052448, 31.8760451],
                                    [120.0054218, 31.87666],
                                    [120.0057813, 31.8774253],
                                    [120.0059422, 31.8776531],
                                    [120.0062265, 31.8779128],
                                    [120.0065752, 31.8782043],
                                    [120.0067136, 31.8782244],
                                    [120.0068853, 31.878197],
                                    [120.0069775, 31.8781588],
                                    [120.0071546, 31.8784184],
                                    [120.0072457, 31.8785915],
                                    [120.0074914, 31.8784703],
                                    [120.0076213, 31.8785277],
                                    [120.0079147, 31.8785321],
                                    [120.0079571, 31.8782628],
                                    [120.0088191, 31.8784016],
                                    [120.0089401, 31.8785277],
                                    [120.0089999, 31.8787008],
                                    [120.0089248, 31.8791199],
                                    [120.0091126, 31.8792384],
                                    [120.0092199, 31.8793295],
                                    [120.0092574, 31.8795071],
                                    [120.0095203, 31.8799763],
                                    [120.0095632, 31.880113],
                                    [120.0094022, 31.880154],
                                    [120.009472, 31.8805594],
                                    [120.009295, 31.8805913],
                                    [120.0093325, 31.8807644],
                                    [120.0095514, 31.8807343],
                                    [120.0095353, 31.8806204],
                                    [120.0097187, 31.8805867],
                                    [120.0097627, 31.8807459],
                                    [120.0105403, 31.8806093],
                                    [120.0105073, 31.8804546],
                                    [120.0106404, 31.8804473],
                                    [120.0107487, 31.8807279],
                                    [120.0107809, 31.8811424],
                                    [120.0107219, 31.88127],
                                    [120.0102015, 31.8813155],
                                    [120.0102069, 31.8814203],
                                    [120.0101112, 31.8814246],
                                    [120.0101103, 31.8820626],
                                    [120.0100084, 31.8820626],
                                    [120.0099923, 31.8821719],
                                    [120.0104848, 31.8822102],
                                    [120.0104698, 31.8823951],
                                    [120.0107798, 31.8824197],
                                    [120.0107506, 31.8829271],
                                    [120.0102069, 31.8827823],
                                    [120.0098327, 31.8833216],
                                    [120.0103217, 31.8837254],
                                    [120.0099843, 31.8841675],
                                    [120.0099821, 31.8843456],
                                    [120.0099762, 31.8844918],
                                    [120.0097563, 31.8846635],
                                    [120.0096007, 31.8848457],
                                    [120.0093164, 31.8849277],
                                    [120.0090498, 31.8850001],
                                    [120.0089122, 31.8851598],
                                    [120.0085936, 31.885508],
                                    [120.008147, 31.8860983],
                                    [120.0077661, 31.8858706],
                                    [120.0069078, 31.8856018],
                                    [120.0063231, 31.8853741],
                                    [120.0061782, 31.8852693],
                                    [120.0061664, 31.8850662],
                                    [120.0060495, 31.8849368],
                                    [120.0058242, 31.8847501],
                                    [120.0055828, 31.8845269],
                                    [120.0054369, 31.884433],
                                    [120.0051483, 31.8843993],
                                    [120.0048586, 31.8843811],
                                    [120.0046118, 31.8843948],
                                    [120.0042272, 31.8845396],
                                    [120.0042436, 31.8846314],
                                    [120.0045303, 31.884638],
                                    [120.004939, 31.8846407],
                                    [120.0046225, 31.8853377],
                                    [120.0042578, 31.8862304],
                                    [120.0045474, 31.8862988],
                                    [120.0041009, 31.8873833],
                                    [120.0033903, 31.8871696],
                                    [120.0032157, 31.8877452],
                                    [120.0030411, 31.887757],
                                    [120.0027986, 31.8886263],
                                    [120.0028941, 31.8886327],
                                    [120.0028727, 31.888783],
                                    [120.0029478, 31.888783],
                                    [120.002922, 31.8890499],
                                    [120.002543, 31.8890123],
                                    [120.0023319, 31.8892184],
                                    [120.0023308, 31.8893362],
                                    [120.0019055, 31.8896757],
                                    [120.0019744, 31.8901888],
                                    [120.0015348, 31.8902293],
                                    [120.0014997, 31.8899604],
                                    [120.0005949, 31.8901417],
                                    [120.0001862, 31.8901248],
                                    [119.999587, 31.8904106],
                                    [119.9996108, 31.8898281],
                                    [119.999183, 31.8898397],
                                    [119.9991806, 31.8900572],
                                    [119.9986949, 31.8899608],
                                    [119.9983033, 31.890143],
                                    [119.9981509, 31.8902097],
                                    [119.9982496, 31.8906941],
                                    [119.9986359, 31.890685],
                                    [119.9988933, 31.8906668],
                                    [119.9990824, 31.8906812],
                                    [119.9992498, 31.8907306],
                                    [119.9993732, 31.8908128],
                                    [119.9994995, 31.8908945],
                                    [119.9995263, 31.8909811],
                                    [119.9994566, 31.8910221],
                                    [119.9993064, 31.8909538],
                                    [119.9990918, 31.8909128],
                                    [119.9985876, 31.8908809],
                                    [119.9985608, 31.8911769],
                                    [119.9984159, 31.8912771],
                                    [119.9984106, 31.8914183],
                                    [119.9985734, 31.8918362],
                                    [119.9985017, 31.8919467],
                                    [119.9985017, 31.8920332],
                                    [119.9984213, 31.8921516],
                                    [119.9981048, 31.8923794],
                                    [119.9980672, 31.8924796],
                                    [119.9981316, 31.8926481],
                                    [119.9982496, 31.892762],
                                    [119.9982603, 31.8928622],
                                    [119.9980726, 31.8931263],
                                    [119.9979009, 31.8932356],
                                    [119.9978258, 31.8933632],
                                    [119.9977829, 31.8936045],
                                    [119.9977829, 31.8938049],
                                    [119.9974986, 31.893937],
                                    [119.9978473, 31.8944654],
                                    [119.9976917, 31.8945564],
                                    [119.9979975, 31.8948616],
                                    [119.99774, 31.8950301],
                                    [119.9975683, 31.8950392],
                                    [119.9973913, 31.8948753],
                                    [119.997277, 31.894947],
                                    [119.9971231, 31.8948889],
                                    [119.9969997, 31.8948844],
                                    [119.99693, 31.8949527],
                                    [119.997063, 31.8950866],
                                    [119.9967637, 31.8953034],
                                    [119.9965974, 31.8952123],
                                    [119.9964753, 31.8950445],
                                    [119.9962189, 31.8952576],
                                    [119.9963345, 31.8953353],
                                    [119.9964096, 31.8953717],
                                    [119.9963935, 31.8954582],
                                    [119.996297, 31.8955174],
                                    [119.9959268, 31.8954446],
                                    [119.9959697, 31.8952897],
                                    [119.996092, 31.8951367],
                                    [119.9963613, 31.894898],
                                    [119.9962755, 31.8947386],
                                    [119.9961682, 31.8947477],
                                    [119.9959268, 31.8949299],
                                    [119.995723, 31.8950802],
                                    [119.9955406, 31.8952396],
                                    [119.9953797, 31.8955083],
                                    [119.9950953, 31.8957452],
                                    [119.9948003, 31.8960458],
                                    [119.9945535, 31.8962507],
                                    [119.994339, 31.8963372],
                                    [119.9940815, 31.8965376],
                                    [119.9939152, 31.8967244],
                                    [119.9940117, 31.8968974],
                                    [119.9941888, 31.8970022],
                                    [119.9945804, 31.8967517],
                                    [119.9946125, 31.896984],
                                    [119.9947359, 31.8972572],
                                    [119.9948808, 31.8974622],
                                    [119.9950792, 31.8976808],
                                    [119.9953196, 31.8977828],
                                    [119.9957015, 31.8978174],
                                    [119.9959901, 31.8978283],
                                    [119.9964955, 31.897863],
                                    [119.9967047, 31.8978493],
                                    [119.997063, 31.8977646],
                                    [119.9974128, 31.897699],
                                    [119.9978151, 31.8975806],
                                    [119.9980297, 31.8975624],
                                    [119.9981925, 31.8985003],
                                    [119.9983743, 31.8985923],
                                    [119.9985691, 31.8985878],
                                    [119.9986241, 31.8989234],
                                    [119.9986165, 31.8989833],
                                    [119.9983467, 31.8990651],
                                    [119.9984653, 31.8993028],
                                    [119.9985382, 31.8993996],
                                    [119.9986627, 31.8993841],
                                    [119.999054, 31.8992247],
                                    [119.9991508, 31.8994205],
                                    [119.9989333, 31.8995118],
                                    [119.9990811, 31.8998259],
                                    [119.9985044, 31.8999652],
                                    [119.9985058, 31.9002396],
                                    [119.9983784, 31.9008096],
                                    [119.9983086, 31.900928],
                                    [119.9981423, 31.9010236],
                                    [119.9978902, 31.9010327],
                                    [119.9977024, 31.9010874],
                                    [119.9975415, 31.9011967],
                                    [119.9974932, 31.9013333],
                                    [119.9975469, 31.9016293],
                                    [119.9976595, 31.901816],
                                    [119.9978044, 31.9018479],
                                    [119.9979707, 31.9018343],
                                    [119.9979868, 31.9019845],
                                    [119.9984052, 31.9019481],
                                    [119.9986131, 31.9026791],
                                    [119.9993965, 31.9026786],
                                    [119.9993976, 31.9027587],
                                    [119.9986359, 31.9027724],
                                    [119.9987485, 31.9030457],
                                    [119.9989001, 31.903318],
                                    [119.9988504, 31.9034009],
                                    [119.9983784, 31.9035056],
                                    [119.9984159, 31.9038016],
                                    [119.998421, 31.9041124],
                                    [119.9993823, 31.9039968],
                                    [119.9993332, 31.9036195],
                                    [119.9995585, 31.9035921],
                                    [119.9997463, 31.9046214],
                                    [119.9995317, 31.9046441],
                                    [119.9994244, 31.904166],
                                    [119.9983894, 31.9042889],
                                    [119.9983086, 31.9044301],
                                    [119.998314, 31.9045166],
                                    [119.9984588, 31.9045986],
                                    [119.9990006, 31.9048536],
                                    [119.9993815, 31.9049766],
                                    [119.999816, 31.9050904],
                                    [119.999977, 31.9051177],
                                    [119.9997677, 31.9056109],
                                    [119.9993869, 31.9055094],
                                    [119.9991079, 31.9059602],
                                    [119.9984481, 31.9057325],
                                    [119.9983569, 31.9059238],
                                    [119.998255, 31.9060695],
                                    [119.9981477, 31.9061424],
                                    [119.9988416, 31.9064637],
                                    [119.9986895, 31.906789],
                                    [119.9987914, 31.9068391],
                                    [119.9987914, 31.9069074],
                                    [119.9987163, 31.9069484],
                                    [119.9983676, 31.9068847],
                                    [119.9980243, 31.9067617],
                                    [119.9976016, 31.9073902],
                                    [119.9981745, 31.9076862],
                                    [119.9981048, 31.9079321],
                                    [119.9981531, 31.9080732],
                                    [119.9981531, 31.9081643],
                                    [119.9980297, 31.9082873],
                                    [119.9979653, 31.9084558],
                                    [119.9978473, 31.9088155],
                                    [119.9982968, 31.9088629],
                                    [119.9984073, 31.909275],
                                    [119.9987056, 31.9093984],
                                    [119.9988523, 31.9094569],
                                    [119.998884, 31.909533],
                                    [119.9986841, 31.9098082],
                                    [119.9986254, 31.9099599],
                                    [119.9993904, 31.9099842],
                                    [119.9993654, 31.910086],
                                    [119.999301, 31.9101315],
                                    [119.9986895, 31.9101042],
                                    [119.9985339, 31.9101361],
                                    [119.9982944, 31.9112099],
                                    [119.9992214, 31.911265],
                                    [119.9994673, 31.9113018],
                                    [119.9997624, 31.9114111],
                                    [120.0002387, 31.9115496],
                                    [120.0002505, 31.9114658],
                                    [120.0001003, 31.9114066],
                                    [119.9999019, 31.9113565],
                                    [119.999933, 31.911249],
                                    [120.0002181, 31.9113262],
                                    [120.0003104, 31.9107777],
                                    [120.0003997, 31.9107481],
                                    [120.0004383, 31.9107827],
                                    [120.0003686, 31.9114066],
                                    [120.0010273, 31.9115814],
                                    [120.001082, 31.9117026],
                                    [120.0012261, 31.9117003],
                                    [120.0017419, 31.9117982],
                                    [120.0022201, 31.911841],
                                    [120.00223, 31.911739],
                                    [120.0022086, 31.9116206],
                                    [120.0020047, 31.9115432],
                                    [120.0019983, 31.9114494],
                                    [120.0021914, 31.9114858],
                                    [120.0023588, 31.9115477],
                                    [120.0023051, 31.9120669],
                                    [120.0022837, 31.9125177],
                                    [120.0028201, 31.9121807],
                                    [120.0029381, 31.9125678],
                                    [120.0029596, 31.9128319],
                                    [120.0030025, 31.9134421],
                                    [120.0034048, 31.9135604],
                                    [120.0040689, 31.9136351],
                                    [120.0041277, 31.9139502],
                                    [120.004165, 31.9140918],
                                    [120.0038286, 31.9144848],
                                    [120.0035422, 31.9146528],
                                    [120.003834, 31.9148901],
                                    [120.0043168, 31.9152316],
                                    [120.0045314, 31.9154228],
                                    [120.004762, 31.9156869],
                                    [120.0050415, 31.9159524],
                                    [120.0057678, 31.9157179],
                                    [120.0064845, 31.9154984],
                                    [120.0069936, 31.9154502],
                                    [120.0076481, 31.9153727],
                                    [120.0079474, 31.9153063],
                                    [120.0082961, 31.9152607],
                                    [120.0086877, 31.9152653],
                                    [120.0089237, 31.9153154],
                                    [120.0092252, 31.9154456],
                                    [120.0094934, 31.9155503],
                                    [120.0097187, 31.9156004],
                                    [120.0100138, 31.9157552],
                                    [120.0107058, 31.9160831],
                                    [120.0112208, 31.9163062],
                                    [120.0116338, 31.916502],
                                    [120.0120094, 31.9166249],
                                    [120.0123527, 31.9168071],
                                    [120.0127067, 31.9169573],
                                    [120.0129041, 31.9169819],
                                    [120.0132045, 31.9170275],
                                    [120.0134416, 31.9171486],
                                    [120.0136712, 31.9173553],
                                    [120.0138654, 31.9175903],
                                    [120.0140532, 31.9177633],
                                    [120.0141712, 31.9179773],
                                    [120.014363, 31.9181533],
                                    [120.0146025, 31.9199976],
                                    [120.0141444, 31.9232772],
                                    [120.0138493, 31.9234503],
                                    [120.0137152, 31.9235823],
                                    [120.0132003, 31.9243017],
                                    [120.0125434, 31.9243224],
                                    [120.0123527, 31.924675],
                                    [120.0121113, 31.9251212],
                                    [120.0118967, 31.9254718],
                                    [120.0116017, 31.9257905],
                                    [120.0112744, 31.9261684],
                                    [120.0109311, 31.9267102],
                                    [120.0108184, 31.9268605],
                                    [120.0106575, 31.9268149],
                                    [120.0104054, 31.9268969],
                                    [120.0098475, 31.9273249],
                                    [120.0094773, 31.9271427],
                                    [120.0091877, 31.9276162],
                                    [120.0097542, 31.9279394],
                                    [120.0098421, 31.9279896],
                                    [120.0097027, 31.9284312],
                                    [120.0095256, 31.9286634],
                                    [120.0092842, 31.9288683],
                                    [120.0089409, 31.9290322],
                                    [120.0085064, 31.9293008],
                                    [120.0080397, 31.9295603],
                                    [120.0076964, 31.9296377],
                                    [120.0073155, 31.9296923],
                                    [120.0071438, 31.9298244],
                                    [120.0066878, 31.9302478],
                                    [120.0064894, 31.930316],
                                    [120.0058617, 31.9304936],
                                    [120.0057223, 31.930571],
                                    [120.0056257, 31.9307212],
                                    [120.0055935, 31.9311355],
                                    [120.0055452, 31.9312539],
                                    [120.0053897, 31.931395],
                                    [120.0048682, 31.9317565],
                                    [120.0045314, 31.9320688],
                                    [120.0044455, 31.9322191],
                                    [120.0043382, 31.9324877],
                                    [120.0040861, 31.9334619],
                                    [120.0039037, 31.9339126],
                                    [120.0035979, 31.9343998],
                                    [120.0034424, 31.934723],
                                    [120.0033619, 31.9351009],
                                    [120.0033029, 31.9354787],
                                    [120.0031205, 31.9358338],
                                    [120.0027986, 31.9363482],
                                    [120.0024553, 31.9368262],
                                    [120.0022676, 31.9371859],
                                    [120.0021925, 31.937541],
                                    [120.0020691, 31.9378642],
                                    [120.0019189, 31.9380463],
                                    [120.0018116, 31.9382011],
                                    [120.0018652, 31.9384059],
                                    [120.0019618, 31.9386244],
                                    [120.0021066, 31.9387929],
                                    [120.0023105, 31.9389522],
                                    [120.0024542, 31.939168],
                                    [120.0025412, 31.9394529],
                                    [120.0025948, 31.9398399],
                                    [120.0026152, 31.9402286],
                                    [120.0027128, 31.9403907],
                                    [120.0028416, 31.9405045],
                                    [120.0030454, 31.9406047],
                                    [120.0035711, 31.940764],
                                    [120.0036891, 31.9408732],
                                    [120.0037481, 31.9410599],
                                    [120.0036999, 31.9412875],
                                    [120.0034638, 31.9420249],
                                    [120.0033405, 31.9421661],
                                    [120.0031956, 31.942289],
                                    [120.003024, 31.9423755],
                                    [120.0025787, 31.942512],
                                    [120.0024124, 31.9426304],
                                    [120.0022729, 31.9427669],
                                    [120.0022193, 31.942899],
                                    [120.0022354, 31.9432813],
                                    [120.0023695, 31.9433678],
                                    [120.0025508, 31.9434425],
                                    [120.0027868, 31.9435426],
                                    [120.0028898, 31.9436],
                                    [120.0029757, 31.943732],
                                    [120.0031044, 31.9440779],
                                    [120.003142, 31.9445741],
                                    [120.0030776, 31.9448928],
                                    [120.0028255, 31.9452023],
                                    [120.0025143, 31.9455209],
                                    [120.0023963, 31.9457394],
                                    [120.0023695, 31.9459443],
                                    [120.0024231, 31.9461855],
                                    [120.0026216, 31.9465815],
                                    [120.0027235, 31.9472143],
                                    [120.0027021, 31.9473235],
                                    [120.0026216, 31.9473599],
                                    [120.0026645, 31.9478561],
                                    [120.0027504, 31.9484478],
                                    [120.0027718, 31.948944],
                                    [120.0026753, 31.9492945],
                                    [120.002686, 31.9495994],
                                    [120.0029542, 31.9503004],
                                    [120.0030937, 31.9508238],
                                    [120.0031902, 31.951229],
                                    [120.0033887, 31.9515066],
                                    [120.0037911, 31.95203],
                                    [120.0040378, 31.9524442],
                                    [120.004585, 31.9535412],
                                    [120.004923, 31.9542922],
                                    [120.0052985, 31.9551297],
                                    [120.006087, 31.9565133],
                                    [120.007117, 31.9575101],
                                    [120.0077929, 31.9581973],
                                    [120.0184526, 31.9708521],
                                    [119.9913452, 31.9884018],
                                    [119.9770694, 32.0061804],
                                    [119.9674237, 32.0202481],
                                    [119.9506323, 32.006481],
                                    [119.9486416, 32.0053872],
                                    [119.9466509, 32.0042934],
                                    [119.9428867, 32.0052352],
                                    [119.9312872, 32.0065774],
                                    [119.9285871, 32.0065417],
                                    [119.9129577, 32.006335],
                                    [119.9067665, 32.0099121],
                                    [119.901671, 32.016277],
                                    [119.8973199, 32.0271014],
                                    [119.8942926, 32.0346585],
                                    [119.8913119, 32.0420084],
                                    [119.8917705, 32.0461701],
                                    [119.8931577, 32.0471794],
                                    [119.894377, 32.0490309],
                                    [119.8913037, 32.0492681],
                                    [119.8854227, 32.0500409],
                                    [119.8818543, 32.0469201],
                                    [119.8817383, 32.0413484],
                                    [119.8782239, 32.0413298],
                                    [119.8740534, 32.0434581],
                                    [119.8694965, 32.0495386],
                                    [119.8680334, 32.0547409],
                                    [119.8692002, 32.0562564],
                                    [119.8663319, 32.0606483],
                                    [119.8641909, 32.0606914],
                                    [119.8545782, 32.0536622],
                                    [119.845539, 32.0607805],
                                    [119.8402095, 32.0617334],
                                    [119.8349773, 32.0588304],
                                    [119.8348264, 32.0562183],
                                    [119.8274843, 32.054466],
                                    [119.82194, 32.054373],
                                    [119.8150469, 32.05747],
                                    [119.7965331, 32.0578339],
                                    [119.7946766, 32.0563085],
                                    [119.7865572, 32.0465744],
                                    [119.7827466, 32.0351737],
                                    [119.7815688, 32.0313917],
                                    [119.7777168, 32.0282518],
                                    [119.7763576, 32.0196527],
                                    [119.7728278, 32.0192709],
                                    [119.7721612, 32.0165702],
                                    [119.7806869, 32.0154011],
                                    [119.7792059, 32.0103334],
                                    [119.7746057, 32.0101635],
                                    [119.7742173, 32.0055675],
                                    [119.7757457, 32.0010742],
                                    [119.775558, 31.9935655],
                                    [119.7734945, 31.9921973],
                                    [119.7718649, 31.9871083],
                                    [119.7738649, 31.986857],
                                    [119.7736427, 31.9845952],
                                    [119.7723404, 31.9844542],
                                    [119.7723834, 31.9820819],
                                    [119.7691174, 31.9795999],
                                    [119.7694191, 31.9727353],
                                    [119.7676734, 31.9628624],
                                    [119.7636507, 31.9590834],
                                    [119.7658017, 31.9546525],
                                    [119.767124, 31.950912],
                                    [119.7664978, 31.9486916],
                                    [119.772742, 31.9489746],
                                    [119.7728838, 31.9400412],
                                    [119.7792745, 31.9383607],
                                    [119.7808883, 31.9325984],
                                    [119.787717, 31.9311111],
                                    [119.7871459, 31.9275963],
                                    [119.783791, 31.9254529],
                                    [119.7803095, 31.9255786],
                                    [119.7785798, 31.9239299],
                                    [119.7774849, 31.9226575],
                                    [119.7788958, 31.9221277],
                                    [119.7780423, 31.9169572],
                                    [119.777594, 31.9156387],
                                    [119.7779257, 31.914192],
                                    [119.7782818, 31.9132421],
                                    [119.7775129, 31.9133963],
                                    [119.7772434, 31.9124012],
                                    [119.7765386, 31.9108775],
                                    [119.7779122, 31.9093987],
                                    [119.777938, 31.9087332],
                                    [119.7778157, 31.9087357],
                                    [119.7778516, 31.9081947],
                                    [119.7773334, 31.9075932],
                                    [119.7770105, 31.9059293],
                                    [119.7764505, 31.9052006],
                                    [119.7766567, 31.9045694],
                                    [119.7687537, 31.90376],
                                    [119.7657907, 31.9015589],
                                    [119.7649162, 31.8993058],
                                    [119.7612721, 31.8960876],
                                    [119.7627872, 31.8949773],
                                    [119.7593461, 31.8920625],
                                    [119.7581609, 31.8931946],
                                    [119.7552983, 31.8894123],
                                    [119.7497163, 31.8921254],
                                    [119.7493459, 31.8885404],
                                ],
                            ],
                        ],
                    },
                },
            ],
        }); };
        // 常州市新北区地图的范围
        Dict.handlers.ResourceGisXinbeiquMapExtent = function () { return [
            [119.438, 32.13607],
            [120.33419, 31.74221],
        ]; };
        // 常州市新北区中心点
        Dict.handlers.ResourceGisXinbeiquCenterPoint = function () { return [119.879673, 31.933156]; };
    },
    initRemote: function () { },
};
